export default {
    x: 50,
    y: 100,
    bird: './image/bird.png',
}